import React from "react";
import { InfoContainer } from "./styles";
import { UserOutlined, ClockCircleOutlined } from "@ant-design/icons";

export const LineInfoContainer = ({
	peopleAhead,
	realWaitStimated,
	call,
	waitingTicket,
	desktop,
	virtualRoom,
}) => {
	return (
		<InfoContainer desktop={desktop} virtualRoom={virtualRoom}>
			<div>
				<span>
					<UserOutlined />
					{peopleAhead > 0 ? peopleAhead - 1 : "-"}
				</span>
				{virtualRoom ? (
					<p>Personas en fila </p>
				) : (
					<p>Personas antes de ti</p>
				)}
			</div>
			<div>
				<span style={{ width: "80%" }}>
					<ClockCircleOutlined />
					{realWaitStimated}
				</span>
				<p>
					Minutos de espera
					{realWaitStimated > 1 ? " estimados" : " estimado"}
				</p>
			</div>
			{!virtualRoom && (
				<div>
					<span>
						{call && parseInt(call?.number) > 0
							? waitingTicket
							: "-"}
					</span>
					<p>Ticket en atención</p>
				</div>
			)}
		</InfoContainer>
	);
};
